<div class="external-file-upload-container position-relative">
  <irembogov-file-upload-selector
    [loadingFile]="loadingFile || uploadStatus === 'uploading'"
    [progress]="progress"
    [filePath]="filePath"
    [totalPreviousAttachments]="totalPreviousAttachments"
    [totalCertificateAttachments]="totalCertificateAttachments"
    [previousAttachments]="previousAttachments"
    [certificateAttachments]="certificateAttachments"
    [id]="field.key"
    [minimumUploadSize]="field.props['minimumUploadSize']"
    [maximumUploadSize]="field.props['maximumUploadSize']"
    [noFileActionLabel]="noFileActionLabel | translate"
    [dragAndDropText]="noFileSubLabelHtml | translate"
    [maxSizeText]="maxSizeText | translate"
    [formControl]="formControl"
    [allowedFormats]="field.props['allowedFormats']"
    [photoValidationResponse]="photoValidationResponse"
    [validatePhoto]="field.props['validatePhoto']"
    [validatingPhoto]="validatingPhoto"
    [attachmentCode]="field.props['attachmentCode']"
    [allowUploadPreviousFiles]="allowUploadPreviousFiles"
    [(duplicateFile)]="duplicateFile"
    [isCertificate]="field.props['isCertificate']"
    [validations]="field.props['validations']"
    [loadFileContentAsBase64Data]="true"
    [disableVirusScan]="true"
    (fileUploadEvent)="onFileUploadEvent($event)"
    (selectFileEvent)="onSelectFile()"
    (selectPreviousAttachmentEvent)="selectPreviousAttachmentEvent($event)"
    (selectCertificateAttachmentEvent)="
      selectCertificateAttachmentEvent($event)
    "
    (previousAttachmentEventScroll)="handlePreviousAttachmentPagination($event)"
    (certificateAttachmentEventScroll)="
      handleCertificateAttachmentPagination($event)
    "
    (handleValidationErrors)="handleFileValidationErrors($event)">
  </irembogov-file-upload-selector>
</div>
